import {
	ajax,
} from '@utils/ajax';

export const jwtAuthServiceService = ajax.create('jwt-auth-service', {
	baseURL: '/',
});
